
/**
 * Internal dependencies
 */
import * as actions from 'state/action-types';
import { createOpenModalAction, createCloseModalAction } from 'state/ui/actions';
import { isModalVisible } from 'state/ui/selectors';
import { editLocationWebsite } from 'state/location-websites/actions';


const openModal = createOpenModalAction('EditLocationWebsiteModal');
const closeModal = createCloseModalAction('EditLocationWebsiteModal');

export const startEditingLocationWebsite = (locationWebsiteId, edits) => dispatch => {
    dispatch({
        type: actions.START_EDITING_LOCATION_WEBSITE,
        payload: { locationWebsiteId }
    })
    dispatch(editLocationWebsite(locationWebsiteId, edits));
    dispatch(openModal());
}


export const stopEditingLocationWebsite = () => dispatch => {
    dispatch({
        type: actions.STOP_EDITING_LOCATION_WEBSITE
    })
    dispatch(closeModal());
}